import { takeLatest, call, put, all } from 'redux-saga/effects';
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_DETRAN_CRV } from 'services/_path';
import { ReducerAction } from 'store/modules/types';
import { IImpressaoSegundaViaLicenciamento } from 'pages/DetranCrv/Processos/ImpressaoSegundaViaLicenciamento/Consulta/form';
import { Types } from './types';
import {
	impressaoSegundaViaLicenciamentoSuccess,
	impressaoSegundaViaLicenciamentoFailure,
} from './actions';

function* impressaoSegundaViaLicenciamentoRequest(request: ReducerAction) {
	const { payload }: { payload: IImpressaoSegundaViaLicenciamento } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_DETRAN_CRV,
		`processos/${CHANNEL}/impressao/segundas-vias-licenciamentos`,
		payload,
	);
	if (response.status === 200 || response.status === 201) {
		yield put(impressaoSegundaViaLicenciamentoSuccess(response));
	} else if (response.error) {
		yield put(impressaoSegundaViaLicenciamentoFailure(response.message));
	}
}

export default all([
	takeLatest(
		Types.IMPRESSAO_SEGUNDA_VIA_LICENCIAMENTO_REQUEST,
		impressaoSegundaViaLicenciamentoRequest,
	),
]);
